/**
 * The three-branch rule that decides which day the drill-down opens on.
 * Card R7, SCORES-14/Q72.
 */

/** Which day the league drill-down opens on when the URL carries no
 *  `?date=`. SCORES-14 / Q72, in order:
 *    1. today, if today has games
 *    2. otherwise the nearest FUTURE day with games
 *    3. otherwise the last day with games -- from the local window if it
 *       holds one, else `lastPlayedDay` from POST /event/last-played-get
 *  Returns null only when the league has never played. */
export function resolveLandingDay(input: {
  todayDay: string;
  /** From POST /event/days-with-games-list. Any order; sorted internally. */
  daysWithGames: readonly string[];
  /** From POST /event/last-played-get. null when hasEverPlayed is false. */
  lastPlayedDay: string | null;
}): string | null {
  const sorted = [...input.daysWithGames].sort();

  if (sorted.includes(input.todayDay)) {
    return input.todayDay;
  }

  const nextFuture = sorted.find((day) => day > input.todayDay);
  if (nextFuture !== undefined) {
    return nextFuture;
  }

  const pastDays = sorted.filter((day) => day < input.todayDay);
  const lastPast = pastDays[pastDays.length - 1];
  if (lastPast !== undefined) {
    return lastPast;
  }

  return input.lastPlayedDay;
}
